import React from 'react'
import ReactSelect from 'react-select'
import styles from './TypeHeaderInput.module.css'
import headersForms from '../../../../../../../components/HeadersForms/headersForms'

const customStyles = {
  control: (provided, state) => ({
    ...provided,
    background: 'var(--white)',
    borderColor: 'var(--washed-gray)',
    minHeight: '28px',
    height: '28px',
    boxShadow: state.isFocused ? null : null,
  }),
  valueContainer: (provided, state) => ({
    ...provided,
    height: '28px',
    padding: '0 6px',
  }),
  input: (provided, state) => ({
    ...provided,
    margin: '0px',
  }),
  singleValue: (provided, state) => ({
    ...provided,
    color: 'var(--dark-gray)',
    fontFamily: 'var(--sans-serif)',
    fontSize: 'var(--size-font-input)',
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isFocused
      ? 'var(--darkened-background)'
      : 'var(--white)',
    color: state.isFocused ? 'var(--dark-gray)' : 'var(--dark-gray)',
  }),
  menu: (provided, state) => ({
    ...provided,
    backgroundColor: 'var(--white)',
  }),
  indicatorSeparator: (state) => ({
    display: 'none',
  }),
  indicatorsContainer: (provided, state) => ({
    ...provided,
    height: '28px',
  }),
}

const TypeHeaderInput = ({ name, value, onChange }) => {
  const handleChange = (selectedOption) => {
    onChange({
      target: {
        name: name,
        value: selectedOption ? { typeHeader: selectedOption.value } : '',
      },
    })
  }

  const selectedOption = headersForms.find(
    (option) => option.value === (value && value.typeHeader)
  )

  return (
    <div className={styles.container}>
      <ReactSelect
        value={selectedOption}
        onChange={handleChange}
        options={headersForms}
        styles={customStyles}
      />
    </div>
  )
}

export default TypeHeaderInput
